/* Keep the parent menu of the chosen entry link, including on shared destinations. */
(function () {
  'use strict';
  if (window.LplNavigationEntry) return;
  var storageKey = 'lpl_navigation_pending_v1';
  var historyKey = '__lplNavigationEntry';
  var current = null;
  var pendingSameDocument = null;

  function path(url) {
    try {
      var target = new URL(url, window.location.href);
      if (target.origin !== window.location.origin) return null;
      return target.pathname.replace(/\/+$/, '') || '/';
    } catch (_) { return null; }
  }

  function roots() { return Array.from(document.querySelectorAll('[data-lpl-nav-entry]')); }
  function keysFor(destination) {
    return Array.from(new Set(roots().filter(function (root) {
      if (destination === path(window.location.href) && root.dataset.lplNavCurrent === 'true') return true;
      return Array.from(root.querySelectorAll('a[href]')).some(function (link) {
        return link.getAttribute('href').charAt(0) !== '#' && path(link.href) === destination;
      });
    }).map(function (root) { return root.dataset.lplNavEntry; })));
  }

  function paint(key) {
    roots().forEach(function (root) {
      var active = key !== null && root.dataset.lplNavEntry === key;
      root.querySelectorAll('[data-lpl-nav-label]').forEach(function (label) {
        label.classList.toggle(label.dataset.lplNavActiveClass, active);
      });
    });
    current = key;
  }

  function save(key) {
    try {
      var state = window.history.state;
      // Preserve other theme/app history state; do not replace primitive state owned elsewhere.
      if (state !== null && typeof state !== 'object') return;
      var next = Object.assign({}, state || {});
      next[historyKey] = { path: path(window.location.href), key: key };
      window.history.replaceState(next, '');
    } catch (_) {}
  }

  function restore() {
    var destination = path(window.location.href);
    var candidates = keysFor(destination);
    var saved = window.history.state && window.history.state[historyKey];
    var key = saved && saved.path === destination ? saved.key : undefined;
    if (pendingSameDocument && pendingSameDocument.path === destination) {
      key = pendingSameDocument.key;
      pendingSameDocument = null;
    }
    if (key === undefined) {
      try {
        var pending = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        window.sessionStorage.removeItem(storageKey);
        if (pending && pending.path === destination && Date.now() - pending.at >= 0 && Date.now() - pending.at < 60000 && (!document.referrer || path(document.referrer) === pending.from)) key = pending.key;
      } catch (_) {}
    }
    if (key === undefined || (key !== null && candidates.indexOf(key) === -1)) key = candidates.length === 1 ? candidates[0] : null;
    paint(key);
    save(key);
  }

  function remember(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    var destination = path(link.href);
    if (destination === null) return;
    var entry = link.closest('[data-lpl-nav-entry]');
    var candidates = keysFor(destination);
    var key = entry ? entry.dataset.lplNavEntry : (candidates.indexOf(current) !== -1 ? current : (candidates.length === 1 ? candidates[0] : null));
    if (destination === path(window.location.href)) {
      if (entry) {
        if (new URL(link.href).hash !== window.location.hash) pendingSameDocument = { key: key, path: destination };
        paint(key); save(key);
      }
      return;
    }
    try { window.sessionStorage.setItem(storageKey, JSON.stringify({ key: key, path: destination, from: path(window.location.href), at: Date.now() })); } catch (_) {}
  }

  window.LplNavigationEntry = { refresh: restore };
  document.addEventListener('click', remember);
  window.addEventListener('pageshow', restore);
  window.addEventListener('popstate', restore);
  document.addEventListener('shopify:section:load', restore);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { once: true });
  else restore();
})();
